module.exports = __webpack_public_path__ + "img/stelzer.dcb20998.png";